import { useForm } from "react-hook-form";

import { FilterValues } from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/filters/filter-schema";
import { DEFAULT_MILE_RANGE } from "@/lib/constants";

export default function useFiltersForm({
  overrideValues,
}: {
  overrideValues: FilterValues;
}) {
  const filterDefaults: FilterValues = {
    radius: DEFAULT_MILE_RANGE,
    showSchoolsWithNoRoles: false,
    quickApply: false,
    savedSchools: false,
    districts: [],
    schools: [],
    grades: [],
    subjects: [],
    address: "",
  };

  const form = useForm<FilterValues>({
    defaultValues: {
      ...filterDefaults,
      ...overrideValues,
    },
  });

  return { form, filterDefaults };
}
